<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23" fill="none">
                    <path
                        d="M4.38821 16.1254L2 21.6979H22.6979L20.3096 16.1254M4.38821 16.1254H20.3096M4.38821 16.1254H5.85728M20.3096 16.1254H18.8406M19.5136 8.16464C19.5136 12.9411 12.3489 18.5136 12.3489 18.5136C12.3489 18.5136 5.18429 12.9411 5.18429 8.16464C5.18429 4.2623 8.44659 1 12.3489 1C16.2513 1 19.5136 4.2623 19.5136 8.16464ZM12.3489 10.5529C13.6679 10.5529 14.7371 9.48362 14.7371 8.16464C14.7371 6.84566 13.6679 5.77643 12.3489 5.77643C11.0299 5.77643 9.96071 6.84566 9.96071 8.16464C9.96071 9.48362 11.0299 10.5529 12.3489 10.5529Z"
                        stroke="#3682F3" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Endereço IP</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Cidade</div>
                            <div class="item__container--value">{{ city }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Continente</div>
                            <div class="item__container--value">{{ continent }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Pais</div>
                            <div class="item__container--value">{{ country }}
                                <svg v-if="country === 'Brasil'" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 72 72"><path fill="#5c9e31" d="M5 17h62v38H5z"/><path fill="#fcea2b" d="m59.023 36.023l-23.157 14.63l-22.889-14.362l23.157-14.63z"/><circle cx="36" cy="36" r="9" fill="#1e50a0"/><path fill="#fff" d="M44.159 39.782a9 9 0 0 0 .696-2.26a11.474 11.474 0 0 0-17.477-4.04a9 9 0 0 0-.352 2.013a10.998 10.998 0 0 1 17.133 4.287"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M5 17h62v38H5z"/></svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Local</div>
                            <div class="item__container--value">{{ location }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Postal</div>
                            <div class="item__container--value">{{ postal }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Pais Registrado</div>
                            <div class="item__container--value">{{ registeredCountry }}
                                <svg v-if="registeredCountry === 'Brasil'" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 72 72"><path fill="#5c9e31" d="M5 17h62v38H5z"/><path fill="#fcea2b" d="m59.023 36.023l-23.157 14.63l-22.889-14.362l23.157-14.63z"/><circle cx="36" cy="36" r="9" fill="#1e50a0"/><path fill="#fff" d="M44.159 39.782a9 9 0 0 0 .696-2.26a11.474 11.474 0 0 0-17.477-4.04a9 9 0 0 0-.352 2.013a10.998 10.998 0 0 1 17.133 4.287"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M5 17h62v38H5z"/></svg>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Risco</div>
                            <div class="item__container--value">{{ risk }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Subdivisao</div>
                            <div class="item__container--value">{{ subdivisions }}</div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableClient',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysis"]
        },
        city() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.city && this.data.risk_body.ip_address.city.names && this.data.risk_body.ip_address.city.names.en ? this.data.risk_body.ip_address.city.names.en : '---';
        },
        continent() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.continent && this.data.risk_body.ip_address.continent.names && this.data.risk_body.ip_address.continent.names['pt-BR'] ? this.data.risk_body.ip_address.continent.names['pt-BR'] : '---';
        },
        country() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.country && this.data.risk_body.ip_address.country.names && this.data.risk_body.ip_address.country.names['pt-BR'] ? this.data.risk_body.ip_address.country.names['pt-BR'] : '---';
        },
        location() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.location && this.data.risk_body.ip_address.location.time_zone ? this.data.risk_body.ip_address.location.time_zone : '---';
        },
        postal() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.postal && this.data.risk_body.ip_address.postal.code ? this.data.risk_body.ip_address.postal.code : '---';
        },
        registeredCountry() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.registered_country && this.data.risk_body.ip_address.registered_country.names && this.data.risk_body.ip_address.registered_country.names['pt-BR'] ? this.data.risk_body.ip_address.registered_country.names['pt-BR'] : '---';
        },
        risk() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.risk ? this.data.risk_body.ip_address.risk : '---';
        },
        subdivisions() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address &&this.data.risk_body.ip_address.subdivisions && this.data.risk_body.ip_address.subdivisions[0] && this.data.risk_body.ip_address.subdivisions[0].names && this.data.risk_body.ip_address.subdivisions[0].names.en ? this.data.risk_body.ip_address.subdivisions[0].names.en : '---';
        },

    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;

                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.item__container--value {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>